module.exports = __webpack_public_path__ + "img/bg8.8bf4f02f.jpg";